<template>
  <div>
    <ShippingAddFormRestrictedAdd ref="newRestricted" @add="newData" @edit="editData" />
    <el-row type="flex" justify="end">
      <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
        <el-button
          class="right"
          type="primary"
          icon="el-icon-plus"
          @click="open"
          >{{ $t("adicionar") }}</el-button
        >
      </el-col>
    </el-row>
    <ShippingAddFormRestrictedTable :tableData="tableData" @remove="remove" @edit="edit" />
  </div>
</template> 
<script>
import ShippingAddFormRestrictedAdd from "./ShippingAddFormRestrictedAdd.vue";
import ShippingAddFormRestrictedTable from "./ShippingAddFormRestrictedTable.vue";
import TableColumnButton from "./TableColumnButton.vue";

export default {
  name: "ShippingAddFormRestricted",
  props: ['tableData'],
  data() {
    return {
      index: -1,
      dialog: false,
    };
  },
  methods: {
    editData(restrictedData) {
      this.$emit("edit", this.index, restrictedData);
    },
    newData(restrictedData) {
      this.$emit("add", restrictedData);
    },
    open() {
      this.index = -1;
      this.$refs.newRestricted.open();
    },
    edit(index, data) {
      this.index = index;
      this.$refs.newRestricted.open(data);
    },
    remove(index) {
      this.$emit("remove", index);
    },
  },
  components: { ShippingAddFormRestrictedAdd, TableColumnButton, ShippingAddFormRestrictedTable }
}
</script>

<style>
.uppercase {
  text-transform: uppercase;
}
</style>